import { lazy } from "react";

const AccountListPage = lazy(() => import("./account-list"));
const AccountUpdatePage = lazy(() => import("./account-update"));

export { AccountListPage, AccountUpdatePage };
